import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	noConditions: {
		id: 'servicedesk-sla-settings.metrics.metric.metric-view.conditions.condition.no-conditions',
		defaultMessage: 'No conditions',
		description: 'empty condition',
	},
});
